module.exports = __webpack_public_path__ + "img/agronegocio.2a3ee658.png";